let apply_for_practice_account = function( $ ) {

	let $apply_link,
		$cancel_link;

	let _init = function() {
		$apply_link = $( '#upgrade-to-practice-account' );
		$cancel_link = $( '#cancel-practice-account-application' );

		if ( $apply_link.length > 0 ) {
			_setup_apply_trigger();
		}

		if ( $cancel_link.length > 0 ) {
			_setup_cancel_trigger();
		}
	};

	let _setup_apply_trigger = function() {
		$apply_link.on( 'click', function( e ) {
			e.preventDefault();

			let redirect = $( this ).attr( 'href' );

			redirect = redirect === '#' ? '' : redirect;

			_apply_for_account( redirect );
		});
	};

	let _setup_cancel_trigger = function() {
		$cancel_link.on( 'click', function( e ) {
			e.preventDefault();

			let redirect = $( this ).attr( 'href' );

			redirect = redirect === '#' ? '' : redirect;

			_cancel_application( redirect );
		})
	};

	let _apply_for_account = function( redirect_after ) {
		$apply_link.closest( 'div' ).loading();

		redirect_after = redirect_after ? redirect_after : false;

		let data = {
			nonce: ScriptData.crate_apply_for_practice_account_nonce,
			action: 'crate_apply_for_practice_account'
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( ! $apply_link.closest( '.crate-modal' ).length > 0 ) {
					_show_notice( 'success', 'Application successful redirecting...' );
				}

				if ( redirect_after ) {
					window.location.href = redirect_after;
				} else {
					window.location.reload();
				}
			} else {
				if ( ! $apply_link.closest( '.crate-modal' ).length > 0 ) {
					_show_notice( 'error', 'Woops! Something has gone wrong with your application please refresh and try again.' );
				}
			}

			$apply_link.closest( 'div' ).loaded();
		} );
	};

	let _cancel_application = function( redirect_after ) {
		$cancel_link.closest( 'div' ).loading();

		redirect_after = redirect_after ? redirect_after : false;

		let data = {
			nonce: ScriptData.crate_cancel_practice_account_application_nonce,
			action: 'crate_cancel_practice_account_application'
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( ! $cancel_link.closest( '.crate-modal' ).length > 0  ) {
					_show_notice( 'success', 'Application canceled successful redirecting...' );
				}

				if ( redirect_after ) {
					window.location.href = redirect_after;
				} else {
					window.location.reload();
				}
			} else {
				if ( $cancel_link.closest( '.crate-modal' ).length > 0  ) {
					_show_notice( 'error', 'Woops! Something has gone wrong with your cancellation please refresh and try again.' );
				}
			}

			$cancel_link.closest( 'div' ).loaded();
		} );
	};

	let _show_notice = function( type, message ) {
		let $wrapper = $apply_link.closest( 'div' );

		$wrapper.find( '.crate-notice' ).remove();

		$wrapper.prepend( '<div style="display: none" class="crate-notice ' + type + '">' + message + '</div>' );

		$wrapper.find( '.crate-notice' ).slideDown( 300 );

		setTimeout( () => {
			$wrapper.find( '.crate-notice' ).slideUp( 300 );

			setTimeout( () => {
				$wrapper.find( '.crate-notice' ).remove();
			}, 300 );
		}, 3300 );
	};

	$( document ).ready( _init );

} (jQuery);

module.exports = apply_for_practice_account;